import React from "react";
import {
  ResumeBasicDetails as ResumeBasicDetailsType,
  ResumeSocialLinks,
} from "../../Entities/UserProfile";
import { Divider, Tag, Tooltip, Typography } from "antd";
import {
  GithubOutlined,
  GlobalOutlined,
  LinkedinOutlined,
  MailOutlined,
  PhoneOutlined,
} from "@ant-design/icons";

const getInitials = (firstName: string, lastName?: string | null): string => {
  const first = firstName.trim().charAt(0) || "";
  const last = lastName?.trim()?.charAt(0) || "";

  return `${first}${last}`.toUpperCase();
};

const capitalizeFirstLetter = (value: string): string => {
  const trimmed = value.trim();
  if (!trimmed) return "";

  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
};

const SocialLink: React.FC<{
  href: string;
  icon: React.ReactNode;
  label: string;
}> = ({ href, icon, label }) => (
  <Tooltip title={label}>
    <a href={href} target="_blank" rel="noreferrer">
      <Tag className="resume-social-tag">{icon}</Tag>
    </a>
  </Tooltip>
);

interface ResumeBasicDetailsProps {
  basicDetails: ResumeBasicDetailsType;
  socials: ResumeSocialLinks;
}

const ResumeBasicDetails: React.FC<ResumeBasicDetailsProps> = ({
  basicDetails,
  socials,
}) => {
  const { firstName, lastName, email, phoneNumber } = basicDetails;

  return (
    <div className="resume-preview-card">
      <div className="resume-preview-card-header">
        <div className="resume-preview-card-header-title">
          <span className="material-symbols-outlined">user_attributes</span>
          <Typography.Text strong>Basic Details</Typography.Text>
        </div>
      </div>
      <Divider style={{ margin: 0 }} />
      <div className="resume-basic-info">
        <div className="resume-avatar">
          <span>{getInitials(firstName, lastName || "")}</span>
        </div>
        <div className="resume-basic-info-text">
          <Typography.Text>
            {capitalizeFirstLetter(firstName)}{" "}
            {capitalizeFirstLetter(lastName || "")}
          </Typography.Text>
          <Typography.Text>
            <MailOutlined /> {email}
          </Typography.Text>
          <Typography.Text>
            <PhoneOutlined rotate={90} /> {phoneNumber || "NA"}
          </Typography.Text>
          {(socials.linkedin ||
            socials.github ||
            socials.personalPortfolio) && (
            <div className="resume-social-tags">
              {socials.linkedin && (
                <SocialLink
                  href={socials.linkedin}
                  icon={<LinkedinOutlined />}
                  label="LinkedIn"
                />
              )}
              {socials.github && (
                <SocialLink
                  href={socials.github}
                  icon={<GithubOutlined />}
                  label="GitHub"
                />
              )}
              {socials.personalPortfolio && (
                <SocialLink
                  href={socials.personalPortfolio}
                  icon={<GlobalOutlined />}
                  label="Portfolio"
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResumeBasicDetails;
